module.exports = __webpack_public_path__ + "img/full.517605a6.png";